import React from "react";

const Header = ({ title }) => {
	return (
		<div className="d-flex justify-content-between align-items-center">
			<div className="d-flex align-items-center gap-2">
				{/* <i className="fas fa-bars pr-2"></i> */}
				<h6 className="m-0">{title}</h6>
			</div>
			<div className="d-flex align-items-center gap-3">
				{/* <div className="location-pill">📍 Pune</div> */}
				{/* <div className="avatar"></div> */}
			</div>
		</div>
	);
};

export default Header;
